<!-- <div class="container-with-bg">
  <div class="cover">
    <div>
      <div class="login-card card">
        <h1>LOGIN</h1>
        <form [formGroup]="form" (ngSubmit)="onLogin()">
          <div class="grid w-full justify-items-center">
            <input
              type="text"
              class="form-input"
              [class.error-input]="usernameErrors?.required"
              placeholder="username"
              name="username"
              formControlName="username"
            />
            <label for="username" class="error-label" *ngIf="usernameErrors?.required"
              >Username is required.</label
            >
            <input
              class="form-input"
              formControlName="password"
              [class.error-input]="passwordErrors?.required"
              placeholder="password"
              type="password"
              name="password"
            />
            <label for="username" class="error-label" *ngIf="passwordErrors?.required"
              >Password is required.</label
            >
            <label for="password" class="error-label" *ngIf="passwordErrors?.minLengthError"
              >Password must atleast 8 characters.</label
            >
            <label for="password" class="error-label" *ngIf="isLoginFailed">{{
              errorMessage
            }}</label>
            <app-sm-spinner class="mt-4" *ngIf="isLoading"></app-sm-spinner>

            <a class="link" [routerLink]="['/' + routePath.REGISTRAION]">
              Don't have an account?
            </a>
            <button type="submit">Login</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div> -->

<div class="container-with-bg">
  <div class="cover">
    <section class="auth-container">
      <img
        loading="lazy"
        src="assets/images/app-logo.png"
        alt="Cover Image"
        class="absolute -top-1.5 left-1/2 h-52 -translate-x-1/2 -translate-y-1/2 transform"
      />
      <div class="px-12 pb-12 pt-14 max-md:px-5"></div>
      <form class="mt-6" [formGroup]="form" (ngSubmit)="onLogin()">
        <div class="input-wrapper">
          <input
            type="text"
            id="username"
            placeholder="Username *"
            aria-label="Username"
            formControlName="username"
            class="ib-input"
          />
          <svg-icon src="assets/svg/icons/UserCircle.svg"></svg-icon>
        </div>
        <div *ngIf="usernameErrors?.required" class="mt-1 text-red-600">Username is required.</div>

        <div class="input-wrapper mt-6">
          <input
            type="password"
            id="password"
            placeholder="Password *"
            aria-label="Password"
            autocomplete="on"
            formControlName="password"
            class="ib-input"
          />
          <svg-icon src="assets/svg/icons/Key.svg"></svg-icon>
        </div>
        <div *ngIf="passwordErrors?.required" class="mt-1 text-red-600">Password is required.</div>
        <div *ngIf="passwordErrors?.minLengthError" class="mt-1 text-red-600">
          Password must be at least 8 characters.
        </div>
        <div *ngIf="isLoginFailed" class="mt-1 text-red-600">{{ errorMessage }}</div>

        <button class="primary-btn mt-6 h-10 w-full px-8 font-semibold max-md:px-5" type="submit">
          Login
        </button>
        <div class="mt-6 text-center">
          <span class="text-white sm:font-semibold sm:text-zinc-800">Don’t have an account?</span>
          <!-- <a
            class="font-bold text-white hover:underline sm:text-sm sm:text-blue-600 sm:hover:text-blue-800 sm:hover:underline"
            [routerLink]="['/' + routePath.REGISTRAION]"
          >
            Register Here.
          </a> -->
        </div>
      </form>
    </section>
  </div>
</div>
